import React from "react";

import { faBolt as bolt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouter } from "next/router";
import PropTypes from "prop-types";

import SpanishIcon from "@/icons/SpanishIcon";
import { SEARCH_ROUTE } from "@/search/search.constants";
import { iconsContainerCss } from "./CardInfoIcons.style";

const propTypes = {
  features: PropTypes.shape({
    has_power_words: PropTypes.bool,
    available_in_spanish: PropTypes.bool,
  }).isRequired,
  userProperties: PropTypes.shape({
    isStudent: PropTypes.bool,
    canViewPowerWords: PropTypes.bool,
  }).isRequired,
};

const CardInfoIcons = ({ features, userProperties }) => {
  const router = useRouter();
  const { pathname, query } = router;
  const urlParameters = new URLSearchParams(query);
  const isStudent = userProperties?.isStudent;
  const canViewPowerWords = userProperties?.canViewPowerWords;
  const hasPowerWords = features?.has_power_words;

  /**
   * Due to using two formats for icons we need to support announce-able tooltips.
   * Ideally, the title and aria-label would announce the text of the tooltip.
   */
  const iconForPowerWordsActivity = !isStudent &&
    canViewPowerWords &&
    hasPowerWords && (
      <FontAwesomeIcon
        key="powerWords"
        icon={bolt}
        aria-label="Contains Power Word Activity"
        title="Contains Power Word Activity"
      />
    );

  const spanishSearchFilterApplied =
    pathname === SEARCH_ROUTE &&
    urlParameters.get("language")?.split(",")[0] === "es";

  const showSpanishIcon =
    features?.available_in_spanish || spanishSearchFilterApplied;

  const iconForAvailableInSpanish = showSpanishIcon && (
    <SpanishIcon
      role="img"
      aria-label="Also available in Spanish"
      title="Also available in Spanish"
    />
  );

  return (
    <div css={iconsContainerCss}>
      {iconForAvailableInSpanish}
      {iconForPowerWordsActivity}
    </div>
  );
};

CardInfoIcons.propTypes = propTypes;
CardInfoIcons.displayName = "CardInfoIcons";

export default CardInfoIcons;
